module.exports = __webpack_public_path__ + "static/media/4ODA7.94b202aa.jpg";